<template>
  <!-- eslint-disable vue/no-v-html -->
  <RuesBoxSize :size="props.item?.width ?? 12">
    <div class="py-6 px-4 md:py-8 md:px-7 my-7 bg-neutral-50 rounded-xl rues-ugc-text">
      <UiHeadline v-if="props.item?.headline" design="h2" type="h2" class="mb-4">
        <span v-if="props.item?.headline" v-html="props.item.headline" />
      </UiHeadline>
      <UiHeadline v-else design="h2" type="h2" class="mb-4">
        {{ t('headline', { region: portal.location ?? '' }) }}
      </UiHeadline>

      <div class="border border-neutral-100 rounded-xl overflow-hidden bg-white">
        <div
          v-for="group in props.item?.items"
          :key="group.name"
          class="py-4 px-5 border-b border-neutral-100 last:border-b-0"
        >
          <div class="flex items-center gap-2 mb-3">
            <UiIcon src="/svg/icons/location.svg" width="18" height="18" class="fill-neutral-900 " />
            <span class="text-xl font-semibold leading-[1.3]" v-html="group.title" />
            <template v-for="tag in group.tags" :key="tag">
              <span class="text-xs rounded-sm py-0.5 px-2 font-medium whitespace-nowrap text-[#0A4633] bg-[#D1E7DD] border-0" v-html="tag" />
            </template>
          </div>

          <p
            v-if="group.address"
            class="text-inherit -mt-1 mb-4 pl-5"
            v-html="group.address"
          />

          <div class="flex flex-col gap-3 pl-5">
            <div
              v-for="(quote, index) in group.quotes"
              :key="index"
              class="border-t border-neutral-100 pt-3 first:border-t-0 first:pt-0"
            >
              <p v-if="quote.name" class="text-inherit text-neutral-700 m-0 mb-1" v-html="quote.name" />
              <p class="text-inherit leading-normal m-0" v-html="quote.text" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </RuesBoxSize>
  <!-- eslint-enable vue/no-v-html -->
</template>
<script setup lang="ts">
const { links: portal } = usePortalData()
const t = useTranslations('RuesUGC').translate
interface UGCItem {
  width?: number
  headline?: string
  items?: Array<{
    name: string
    title: string
    tags?: string[]
    address?: string
    quotes?: Array<{
      name?: string
      text: string
    }>
  }>
}

const props = defineProps<{
  item: UGCItem | null
}>()

</script>
<style scoped>
@reference "~/assets/css/main.css";
:deep(.rues-ugc-text){
  a{
    @apply underline cursor-pointer;
  }
}
</style>
